import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import {AppProvider} from '../src/context/context'
import {fonts} from '../src/theme'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <AppProvider>
    <style>{fonts}</style>
    <App />
  </AppProvider>,
)
